import { Accounts } from "../../../services/accounts/types";
import { TransactionsHeroTotals } from "../components/TransactionsHero/types";
import {
  PERIOD_MONTH,
  PERIOD_YEAR,
  RANGE_OPTIONS,
  SORT_OPTIONS,
  TYPE_OPTIONS,
} from "../components/TransactionsFilters/constants";
import {
  FilterValues,
  MonthOption,
} from "../components/TransactionsFilters/types";
import { PeriodState } from "./types";

export const EMPTY_TOTALS: TransactionsHeroTotals = {
  income: 0,
  expense: 0,
  net: 0,
  count: 0,
};

export const MONTH_WINDOW = 6;
export const MOBILE_MONTH_WINDOW = 3;

export const getDefaultFilters = (): FilterValues => ({
  searchBy: "",
  type: TYPE_OPTIONS[0],
  category: null,
  account: null,
  sort: SORT_OPTIONS[0],
});

export const getCurrentPeriod = (): PeriodState => {
  const now = new Date();
  return {
    dateRange: PERIOD_MONTH,
    year: now.getFullYear(),
    month: now.getMonth() + 1,
  };
};

export const getTrailingMonths = (count: number): MonthOption[] => {
  const now = new Date();
  const months: MonthOption[] = [];
  for (let offset = count - 1; offset >= 0; offset -= 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - offset, 1);
    months.push({
      label: date.toLocaleString("en-US", { month: "short" }),
      year: date.getFullYear(),
      month: date.getMonth() + 1,
    });
  }
  return months;
};

export const getPeriodLabel = (period: PeriodState): string => {
  if (period.dateRange === PERIOD_MONTH) {
    const date = new Date(period.year, period.month - 1, 1);
    const monthName = date.toLocaleString("en-US", { month: "long" });
    return `${monthName} ${period.year}`.toUpperCase();
  }
  if (period.dateRange === PERIOD_YEAR) {
    return String(period.year);
  }
  const range = RANGE_OPTIONS.find(
    (option) => option.value === period.dateRange,
  );
  return (range?.label ?? "").toUpperCase();
};

export const noop = async (): Promise<void> => {};

export const idParamOf = (value: string | null): number | undefined => {
  const id = Number(value);
  return value !== null && Number.isInteger(id) && id > 0 ? id : undefined;
};

export const cashbackBuysLabelOf = (
  accounts: Accounts[],
  accountId: number | undefined,
): string | null => {
  if (accountId === undefined) {
    return null;
  }
  const name = accounts.find((account) => account.id === accountId)?.name;
  return `Cashback buys from ${name ?? "this account"}`;
};
